import { render, staticRenderFns } from "./CambiarCostoProductoComponent.vue?vue&type=template&id=4574f728&"
import script from "./CambiarCostoProductoComponent.vue?vue&type=script&lang=js&"
export * from "./CambiarCostoProductoComponent.vue?vue&type=script&lang=js&"
import style0 from "./CambiarCostoProductoComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports